<template>
  <div class="flex justify-between">
    <h2 class="m-0 truncate text-base font-normal leading-6 text-neutral-0 sm:text-lg sm:font-medium">
      {{ title }}
    </h2>
    <button
      v-if="actionLabel"
      class="ml-2 whitespace-nowrap text-sm font-medium text-primary-60 hover:text-primary-40"
      @click="emitValue"
    >
      {{ actionLabel }}
    </button>
  </div>
</template>

<script lang="ts" setup>
// Props
withDefaults(
  defineProps<{
    title: string;
    actionLabel?: string;
  }>(),
  {
    title: "",
    actionLabel: "",
  },
);

// Emits
const emit = defineEmits<{
  (e: "actionClick"): void;
}>();

const emitValue = () => {
  emit("actionClick");
};
</script>
